import { notification } from 'antd';
import { all, call, put, take, select } from 'redux-saga/effects';
import {
  LOAD_POSITION_LIST,
  ADD_POSITION,
  UPDATE_POSITION,
  DELETE_POSITION,
} from '../type';
import {
  loadPositionListSuccessAction,
  loadPositionListErrorAction,
  addPositionSuccessAction,
  addPositionErrorAction,
  updatePositionSuccessAction,
  updatePositionErrorAction,
  deletePositionSuccessAction,
  deletePositionErrorAction,
} from '../action';
import { notifyMessageAction } from 'store/notification/action';
import { getPositionList } from '../selector';

import { positionService } from 'services';

function* loadPositionList() {
  while (1) {
    const action = yield take(LOAD_POSITION_LIST);
    try {
      const listPosition = yield call(
        positionService.loadPositionList,
        action.payload,
      );
      yield put(loadPositionListSuccessAction(listPosition));
    } catch (err) {
      yield put(loadPositionListErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* addPosition() {
  while (1) {
    const action = yield take(ADD_POSITION);
    try {
      const { callback, successMessageId } = action.payload;
      const response = yield call(positionService.adddPosition, action.payload);
      callback && callback(response);
      yield put(
        notifyMessageAction({
          message: {
            id: successMessageId || 'app.position.create.success-message',
          },
        }),
      );
      yield put(addPositionSuccessAction());
    } catch (err) {
      yield put(addPositionErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* updatePosition() {
  while (1) {
    const action = yield take(UPDATE_POSITION);
    try {
      const { callback, successMessageId } = action.payload;
      const response = yield call(
        positionService.updatePosition,
        action.payload,
      );
      callback && callback(response);
      yield put(
        notifyMessageAction({
          message: {
            id: successMessageId || 'app.position.edit.success-message',
          },
        }),
      );
      yield put(updatePositionSuccessAction());
    } catch (err) {
      yield put(updatePositionErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* deletePosition() {
  //TODO: need to be declare a clearly function's name, example: deleteAndReloadPosition or move logic reload to callback
  while (1) {
    const action = yield take(DELETE_POSITION);
    try {
      const { callback, successMessageId } = action.payload;
      const deletedPosition = yield call(
        positionService.deletePosition,
        action.payload,
      );
      const positionList = yield select(getPositionList);
      let newPositionList = positionList.filter(
        item => item.id !== deletedPosition.id,
      );
      callback && callback(deletedPosition);
      yield put(
        notifyMessageAction({
          message: {
            id: successMessageId || 'app.position.delete.success-message',
          },
        }),
      );
      yield put(deletePositionSuccessAction());
      yield put(loadPositionListSuccessAction(newPositionList));
    } catch (err) {
      yield put(deletePositionErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadPositionList(),
    addPosition(),
    updatePosition(),
    deletePosition(),
  ]);
}
